import { app, db } from "../pages/Firebase/FirebaseConfig";
import { auth } from "../pages/Firebase/Firebase";
import { paymentStatuses, verificationStatuses } from "../data/constants";
const {
  collection,
  getDocs,
  addDoc,
  doc,
  setDoc,
  updateDoc,
  serverTimestamp,
  onSnapshot,
  query,
  runTransaction,
  getDoc,
} = require("firebase/firestore");

/**
 * Increments the current submission ID
 * @returns {number|undefined} The incremented submissionID if successful, undefined otherwise
 */
export async function incrementSubmissionId() {
  const docRef = doc(db, "counters", "submission");
  let newID;
  try {
    await runTransaction(db, async (transaction) => {
      const snapshot = await transaction.get(docRef);
      if (!snapshot.exists()) {
        throw "Document does not exist!";
      }

      newID = snapshot.data().submission_id + 1;
      console.log({ newID });
      transaction.update(docRef, { submission_id: newID });
    });
    console.log("Transaction successfully committed!");
    let res = (await getDoc(docRef)).data().submission_id;
    console.log({ newID, res });
    return res;
  } catch (e) {
    console.log("Transaction failed: ", e);
  }
}

/**
 * Add a Firestore document representing a form submission to
 * the admin and user (`owner`) collections.
 *
 * The document contains:
 * - All the form data
 * - The `owner` email address
 * - The `submissionTimestamp`
 * - The dynamically generated `submissionID`
 * - Default values for the payment verification status (`paymentStatus`)
 * and the document verification status (`status`)
 *
 * @param {String} creds An object containing the form data
 * @param {String} owner The email address of the user who submitted the form
 */
export async function createQuery(creds, owner) {
  const objectData = {
    Email: creds.email,
    companyName: creds.agencyName,
    companyEmail: creds.agencyEmail,
    companyContactPersonal: creds.Designation,
    companyContactNumber: creds.agencyNo,
    candidateName: creds.candidateName,
    Univerity: creds.universityName,
    Program: creds.progamName,
    PRN: creds.prn,
    PassingYear: creds.graduationDate,
    Documents: creds.Documents,
    PaymentDate: creds.queryDate,
    NEFTrefNumber: creds.NEFT,
    statusDate: creds.statusDate,
    owner,
    submissionTimestamp: serverTimestamp(),
    submissionID: await incrementSubmissionId(),
    status: verificationStatuses.NOT_VERIFIED,
    paymentStatus: paymentStatuses.NOT_VERIFIED,
  };
  try {
    //Adding new Document user Database
    console.log("adding record to", owner);
    var collectionRef = collection(db, `${owner}`);
    const docRef = await addDoc(collectionRef, objectData);

    //adding new record in Admin Database
    setDoc(doc(db, "verification.exam@mitwpu.edu.in", `${docRef.id}`), objectData);
    return docRef.id;
  } catch (err) {
    console.err("Error while recording submission: ", err);
  }
}

//function for requesting query from firestore database

export async function requestQuery(userID) {
  try {
    const querySnapshot = await getDocs(collection(db, `${userID}`));
    return querySnapshot;
  } catch (err) {
    console.log("The Error is->" + err);
  }
}

export async function getSingleQuery(queryId) {
  try {
    const snapshot = await getDoc(doc(db, "verification.exam@mitwpu.edu.in", queryId));
    return {
      queryId,
      ...snapshot.data(),
    };
  } catch (error) {
    console.error(`Error fetching document verification.exam@mitwpu.edu.in/${queryId}:`, error);
  }
}

export async function setStatus(userId, queryId, status) {
  const time = new Date();
  try {
    const docRef = doc(db, `${userId}`, `${queryId}`);
    await updateDoc(docRef, {
      status,
      statusDate: `${time.toLocaleString()}`,
    });
    console.log(userId, queryId);
  } catch (err) {
    console.log("error setting status:", err);
  }
}

export async function setPaymentStatuses() {
  (await getDocs(collection(db, "verification.exam@mitwpu.edu.in"))).forEach((doc) => {
    updateDoc(doc.ref, { paymentStatus: paymentStatuses.NOT_VERIFIED });
  });
}

export async function setQueryIDs() {
  (await getDocs(collection(db, "verification.exam@mitwpu.edu.in"))).forEach(
    async (document) => {
      const newID = await incrementSubmissionId();
      updateDoc(document.ref, { submissionID: newID });
      updateDoc(doc(db, document.data().owner, document.id), {
        submissionID: newID,
      });
    }
  );
  console.log("set all query ids");
}

export async function setPaymentStatus(id, status) {
  updateDoc(doc(db, "verification.exam@mitwpu.edu.in", id), { paymentStatus: status });
}

export async function onAdminDocumentsChange(callback) {
  const q = query(collection(db, "verification.exam@mitwpu.edu.in"));
  return onSnapshot(q, callback);
}
